class SiteFooter extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: -apple-system, "SF Pro Text", "SF Pro Display",
                       BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif;
        }

        footer {
          height: 60vh;
          position: relative;
          background-color: #b78883;
          overflow: hidden;
        }

        .footer-bg {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          object-fit: contain;
          opacity: 0.9;
          pointer-events: none;
          user-select: none;
        }

        .footer-content {
          position: relative;
          max-width: 80rem;
          margin: 0 auto;
          padding: 2.5rem 1rem;
        }

        .footer-inner {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          color: #000;
          font-size: 16px;
        }

        .footer-address {
          text-align: left;
        }

        .footer-contact {
          text-align: left;
        }

        .footer-contact p {
          margin: 0;
        }

        .font-semibold {
          font-weight: 600;
        }

        @media (min-width: 768px) {
          footer {
            height: 60vh;
          }

          .footer-content {
            padding: 2.5rem 2.5rem;
          }

          .footer-inner {
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
          }
        }
      </style>

      <footer>
        <img 
          src="${new URL('./images/footer.png', import.meta.url).href}" 
          alt="FUE Global"
          loading="lazy" decoding="async"
          class="footer-bg"
        />

        <div class="footer-content">
          <div class="footer-inner">
            <div>
              © 2026 FUE Global. All rights reserved.
            </div>
            <div class="footer-address">
              <span class="font-semibold">Address:</span>
              E-13, Basement Defense Colony,<br/> Ring Rd, New Delhi 110024
            </div>
            <div class="footer-contact">
              <p>
                <span class="font-semibold">Phone:</span> +91 89878 74547
              </p>
              <p>
                <span class="font-semibold">E-mail:</span> scientific@fueasia.org, contact@fueasia.org
              </p>
            </div>
          </div>
        </div>
      </footer>
    `;
  }
}

customElements.define('site-footer', SiteFooter);
